import React, { Component } from 'react';
import axios from "axios";

import api from '../../../api/';

import Create from "./Create.js"
import Edit from "./Edit.js"
import Delete from "./Delete.js"
import Detail from "./Detail.js"

import ParadigmaTable from "../../../components/ParadigmaTable/"



class Empresas extends Component {
    constructor() {
        super();
        this.state = {
            columns: [
                {
                    Header: "id",
                    id: "pk",
                    accessor: "pk",
                    width: 100,
                    show: false,
                    private: true,
                },
                {
                    Header: "Nombre",
                    id: "nombre",
                    accessor: d => d.nombre,
                    show: true,
                },
                {
                    Header: "Razón Social",
                    id: "razonSocial",
                    accessor: d => d.razonSocial,
                    show: true,
                },
                {
                    Header: "CUIT",
                    id: "cuit",
                    accessor: "cuit",
                    filterable: true,
                    width: 100,
                    show: true,
                },
                {
                    Header: "Rubro",
                    id: "rubro__nombre",
                    accessor: "rubro__nombre",
                    filterable: true,
                    width: 100,
                    show: true,
                },
                {
                    Header: "Teléfono",
                    id: "telefono",
                    accessor: "telefono",
                    filterable: false,
                    width: 100,
                    show: true,
                },
                {
                    Header: "Email",
                    id: "email",
                    accessor: "email",
                    filterable: true,
                    width: 200,
                    show: true,
                },
            ]
        };
    }

    render() {
        const { data, pages, loading } = this.state;
        return (
            <ParadigmaTable
                buttons={[
                    {
                        create:true,
                        permission: 'empresas_add',
                        component: Create,
                    },
                    {
                        detail: true,
                        permission: 'empresas_detail',
                        component: Detail,
                    },
                    {
                        edit:true,
                        permission: 'empresas_edit',
                        component: Edit,
                    },
                    {
                        edit:true,
                        permission: 'empresas_delete',
                        component: Delete,
                    }
                ]}

                apiUrl={api.clientes.empresas.list}
                columns={this.state.columns}
                exportUrl={api.clientes.empresas.export}
                title={"Empresas/Organizaciones"}
                outerSort={[{"id":"nombre","desc":false}]}
            />
        );
    }
}

export default Empresas;



// WEBPACK FOOTER //
// ./src/views/clientes/Empresas/Empresas.js